import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { homePageLayout } from './HomeLayout.tsx';
import { newHiresWidget } from './NewHiresCard.tsx';
import { workAnniversariesWidget } from './WorkAnniversariesCard.tsx';
import { recentlyVisitedWidget } from './RecentlyVisitedContent.tsx';

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [
    homePageLayout,
    newHiresWidget,
    workAnniversariesWidget,
    recentlyVisitedWidget,
  ],
});
